import _pt from 'prop-types';
import * as React from 'react';
import { TabPanel as TabPanel$1, Tab, Tabs as Tabs$1, TabList } from 'react-tabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createGenericContext, createBemBlockBuilder } from '@ebsco-ui/utils';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import cn from 'classnames';
import Button from '@ebsco-ui/button';
import { jsx, jsxs } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var ScrollControlTypes;

(function (ScrollControlTypes) {
  ScrollControlTypes["start"] = "start";
  ScrollControlTypes["end"] = "end";
})(ScrollControlTypes || (ScrollControlTypes = {}));

var ICONS = {
  ltr: {
    start: faChevronLeft,
    end: faChevronRight
  },
  rtl: {
    start: faChevronRight,
    end: faChevronLeft
  }
};

var ScrollControl = function ScrollControl(_ref) {
  var isEnabled = _ref.isEnabled,
      isRTL = _ref.isRTL,
      title = _ref.title,
      type = _ref.type,
      onClick = _ref.onClick,
      className = _ref.className;
  var icons = ICONS[isRTL ? "rtl" : "ltr"];
  var onControlClick = onClick.bind(null, type);
  return /*#__PURE__*/jsx(Button, {
    disabled: !isEnabled,
    className: cn(className, "".concat(className, "--").concat(type)),
    onClick: onControlClick,
    "aria-hidden": true,
    tabIndex: -1,
    styleType: "flat-icon",
    type: "button",
    title: title,
    "data-auto": "tabs-scroll-".concat(type),
    children: /*#__PURE__*/jsx(FontAwesomeIcon, {
      icon: icons[type]
    })
  });
};

ScrollControl.defaultProps = {
  isRTL: false
};

var _excluded$3 = ["onAnimationEnd"];

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @see https://stackoverflow.com/a/30527650/5219328
 */
var getScrollStep = function getScrollStep(targetPosition, currentPosition, scrollRate) {
  return Math.ceil((targetPosition - currentPosition) / scrollRate);
};

var isTargetPositionReached = function isTargetPositionReached(targetPosition, currentPosition) {
  return currentPosition === targetPosition || getPositionsDiff(targetPosition, currentPosition) < 1;
};

var getPositionsDiff = function getPositionsDiff(targetPosition, currentPosition) {
  return Math.abs(currentPosition - targetPosition);
};

var AXIS;

(function (AXIS) {
  AXIS["v"] = "v";
  AXIS["h"] = "h";
})(AXIS || (AXIS = {}));

var makeScroller = function makeScroller() {
  var isScrolling = false;
  return function (_ref) {
    var onAnimationEnd = _ref.onAnimationEnd,
        restOptions = _objectWithoutProperties(_ref, _excluded$3);

    if (isScrolling) {
      return;
    }

    isScrolling = true;

    var handleAnimationEnd = function handleAnimationEnd() {
      isScrolling = false;

      if (typeof onAnimationEnd === "function") {
        onAnimationEnd();
      }
    };

    smoothScroll(_objectSpread$3({
      onAnimationEnd: handleAnimationEnd
    }, restOptions));
  };
};

var smoothScroll = function smoothScroll(_ref2) {
  var container = _ref2.container,
      targetScrollPosition = _ref2.targetScrollPosition,
      _ref2$axis = _ref2.axis,
      axis = _ref2$axis === void 0 ? AXIS.v : _ref2$axis,
      _ref2$scrollRate = _ref2.scrollRate,
      scrollRate = _ref2$scrollRate === void 0 ? 5 : _ref2$scrollRate,
      onAnimationEnd = _ref2.onAnimationEnd;

  if (!container) {
    return;
  }

  var scrollProperty = axis === "v" ? "scrollTop" : "scrollLeft";
  var currentScrollPosition = container[scrollProperty] || 0;

  if (isTargetPositionReached(targetScrollPosition, currentScrollPosition)) {
    onAnimationEnd();
    return;
  }

  var diff = getPositionsDiff(targetScrollPosition, currentScrollPosition);

  if (diff < scrollRate) {
    container[scrollProperty] = targetScrollPosition;
  } else {
    var step = getScrollStep(targetScrollPosition, currentScrollPosition, scrollRate);
    container[scrollProperty] = currentScrollPosition + step;
  }

  window.requestAnimationFrame(function () {
    smoothScroll({
      container: container,
      targetScrollPosition: targetScrollPosition,
      axis: axis,
      scrollRate: scrollRate,
      onAnimationEnd: onAnimationEnd
    });
  });
};

var isNegativeRTL = function isNegativeRTL() {
  var ua = navigator.userAgent.toLowerCase(); // @ts-expect-error documentMode does only exist in IE so I don't see any alternative to ts-ignore

  var isIE = !!document.documentMode;
  var isFirefox = ua.indexOf("gecko") > -1;
  var isSafari = ua.indexOf("safari") > -1;
  var isChrome = ua.indexOf("chrome") > -1;
  return (isSafari || isFirefox) && !isChrome && !isIE;
}; // In IE sometimes because of inconvenient rounding we get wrong proportions
// between container and content widths, so scrolling becomes allowed when it shouldn't
// 1px buffer prevents it (though sometimes hides 1px from the real button,
// but it's not really visible.


var getContainerWidthForIE = function getContainerWidthForIE(width) {
  return width + 1;
};

var isScrollingAllowedCases = {
  ltr: {
    all: function all(_ref) {
      var scrollLeft = _ref.scrollLeft,
          scrollWidth = _ref.scrollWidth,
          clientWidth = _ref.clientWidth;
      return {
        start: scrollLeft > 0,
        end: Math.ceil(scrollLeft) < scrollWidth - clientWidth
      };
    },
    ie: function ie(_ref2) {
      var scrollLeft = _ref2.scrollLeft,
          scrollWidth = _ref2.scrollWidth,
          clientWidth = _ref2.clientWidth;
      return {
        start: scrollLeft > 0,
        end: Math.ceil(scrollLeft) < scrollWidth - getContainerWidthForIE(clientWidth)
      };
    }
  },
  rtl: {
    chrome: function chrome(_ref3) {
      var scrollLeft = _ref3.scrollLeft,
          scrollWidth = _ref3.scrollWidth,
          clientWidth = _ref3.clientWidth;
      return {
        start: Math.ceil(scrollLeft) < scrollWidth - clientWidth,
        end: scrollLeft > 0
      };
    },
    negativeRTL: function negativeRTL(_ref4) {
      var scrollLeft = _ref4.scrollLeft,
          scrollWidth = _ref4.scrollWidth,
          clientWidth = _ref4.clientWidth;
      return {
        start: scrollLeft < 0,
        end: Math.ceil(Math.abs(scrollLeft)) < scrollWidth - clientWidth
      };
    },
    ie: function ie(_ref5) {
      var scrollLeft = _ref5.scrollLeft,
          scrollWidth = _ref5.scrollWidth,
          clientWidth = _ref5.clientWidth;
      return {
        start: scrollLeft > 0,
        end: Math.ceil(scrollLeft) < scrollWidth - getContainerWidthForIE(clientWidth)
      };
    }
  }
};
var getIsScrollingAllowed = function getIsScrollingAllowed(_ref6) {
  var element = _ref6.element,
      isRTL = _ref6.isRTL;
  var isScrollingAllowed;

  if (isRTL) {
    if (isNegativeRTL()) {
      // Firefox and safari
      isScrollingAllowed = isScrollingAllowedCases.rtl.negativeRTL;
    } else if (!element.scrollTo) {
      isScrollingAllowed = isScrollingAllowedCases.rtl.ie;
    } else {
      isScrollingAllowed = isScrollingAllowedCases.rtl.chrome;
    }
  } else {
    if (!element.scrollTo) {
      isScrollingAllowed = isScrollingAllowedCases.ltr.ie;
    } else {
      isScrollingAllowed = isScrollingAllowedCases.ltr.all;
    }
  }

  return isScrollingAllowed(element);
};
var getNextScrollingPosition = function getNextScrollingPosition(_ref7) {
  var element = _ref7.element,
      isRTL = _ref7.isRTL,
      type = _ref7.type;
  var start = ScrollControlTypes.start,
      end = ScrollControlTypes.end;
  var scrollWidth = element.scrollWidth,
      currentScroll = element.scrollLeft,
      tabListWidth = element.clientWidth;
  var maxScroll = scrollWidth - tabListWidth;
  var direction = type === end ? 1 : -1; // In all browsers but IE horizontal scrolling is not inverted in RTL,
  // so initial value is equal to container's width
  // In IE it's 0, so we have to scroll in opposite direction

  if (isRTL && element.scrollTo) {
    direction = -1 * direction;
  }

  var nextScroll = currentScroll + tabListWidth * direction;

  if (isRTL && isNegativeRTL()) {
    // Safari and Firefox in RTL mode treat scrollLeft axis negatively,
    // so this entire IF branch is a workaround for this.
    // It is possible to combine calculations inside it with general ones,
    // but I believe that the nested IF, even if ugly, is more readable than
    // any sophisticated formula would be.
    if (type === start && nextScroll > 0) {
      nextScroll = 0;
    } else if (nextScroll < -maxScroll) {
      nextScroll = -maxScroll;
    }
  } else if (nextScroll > maxScroll) {
    nextScroll = maxScroll;
  } else if (nextScroll < 0) {
    nextScroll = 0;
  }

  return nextScroll;
};

var _createGenericContext = createGenericContext({
  errorMessage: "Tabs compound components cannot be rendered outside of the Tabs component"
}),
    useTabsContext = _createGenericContext.useGenericContext;
    _createGenericContext.GenericContextConsumer;
    var TabsContextProvider = _createGenericContext.GenericContextProvider;

var _excluded$2 = ["className", "children"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DisabledTabPanel = function DisabledTabPanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var _useTabsContext = useTabsContext(),
      getBemBlocksWith = _useTabsContext.getBemBlocksWith;

  return /*#__PURE__*/jsx("section", _objectSpread$2(_objectSpread$2({}, rest), {}, {
    className: cn(className, getBemBlocksWith("__tab-panel"), getBemBlocksWith("__tab-panel--disabled")),
    children: children
  }));
};

DisabledTabPanel.propTypes = {
  children: _pt.node,
  className: _pt.string
};

var _excluded$1 = ["children", "className", "ref"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TabPanel = function TabPanel(props) {
  var children = props.children,
      className = props.className;
      props.ref;
      var rest = _objectWithoutProperties(props, _excluded$1);

  var _useTabsContext = useTabsContext(),
      getBemBlocksWith = _useTabsContext.getBemBlocksWith,
      isDisabled = _useTabsContext.isDisabled;

  if (isDisabled) {
    return /*#__PURE__*/jsx(DisabledTabPanel, {
      "data-auto": "disabled-tab-panel",
      className: className,
      children: children
    });
  }

  return /*#__PURE__*/jsx(TabPanel$1, _objectSpread$1(_objectSpread$1({
    "data-auto": "tab-panel",
    className: cn(className, getBemBlocksWith("__tab-panel")),
    selectedClassName: getBemBlocksWith("__tab-panel--selected")
  }, rest), {}, {
    children: children
  }));
};

TabPanel.tabsRole = "TabPanel";

var _excluded = ["children", "className", "disableTabs", "i18n", "isRTL", "tabs", "isTabRequired"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var TAB_LIST_CLASSNAME = "eb-tabs__tab-list";
var ANIMATION_SCROLL_RATE = 5;

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs() {
    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.getBemBlocksWith = createBemBlockBuilder([Tabs.BASE_CLASSNAME, _this.props.className]);
    _this.smoothScroll = makeScroller();
    _this.state = {
      isScrollingAllowed: {
        start: false,
        end: false
      }
    };

    _this.getTabList = function () {
      return document.getElementsByClassName(TAB_LIST_CLASSNAME)[0];
    };

    _this.updateScrollPermissions = function () {
      _this.setState({
        isScrollingAllowed: _this.isScrollingAllowed()
      });
    };

    _this.isScrollingAllowed = function () {
      var isRTL = _this.props.isRTL;

      var element = _this.getTabList(); // tablist may not exist when there is just one tab or tabs are disabled


      if (element) {
        return getIsScrollingAllowed({
          element: element,
          isRTL: isRTL
        });
      } else {
        return {
          start: false,
          end: false
        };
      }
    };

    _this.handleScroll = function (type) {
      var isRTL = _this.props.isRTL;

      var tabList = _this.getTabList();

      var nextScrollingPosition = getNextScrollingPosition({
        element: tabList,
        isRTL: isRTL,
        type: type
      });

      _this.smoothScroll({
        container: tabList,
        targetScrollPosition: nextScrollingPosition,
        axis: AXIS.h,
        scrollRate: ANIMATION_SCROLL_RATE
      });
    };

    _this.renderTab = function (_ref, index) {
      var icon = _ref.icon,
          title = _ref.title,
          disabled = _ref.disabled;
      return /*#__PURE__*/jsxs(Tab, {
        disabled: disabled,
        children: [icon && /*#__PURE__*/jsx(FontAwesomeIcon, {
          icon: icon
        }), title]
      }, "tab-".concat(index));
    };

    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateScrollPermissions();
      window.addEventListener("resize", this.updateScrollPermissions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateScrollPermissions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children;
          _this$props.className;
          var disableTabs = _this$props.disableTabs,
          _this$props$i18n = _this$props.i18n,
          scrollControlStartTitle = _this$props$i18n.scrollControlStartTitle,
          scrollControlEndTitle = _this$props$i18n.scrollControlEndTitle,
          isRTL = _this$props.isRTL,
          tabs = _this$props.tabs,
          isTabRequired = _this$props.isTabRequired,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var _this$state$isScrolli = this.state.isScrollingAllowed,
          start = _this$state$isScrolli.start,
          end = _this$state$isScrolli.end;
      var isDisabled = disableTabs || tabs.length < 2 && !isTabRequired;
      var tabsContext = {
        isDisabled: isDisabled,
        getBemBlocksWith: this.getBemBlocksWith
      };

      if (isDisabled) {
        return /*#__PURE__*/jsx(TabsContextProvider, {
          value: tabsContext,
          children: /*#__PURE__*/jsx("div", {
            className: this.getBemBlocksWith(),
            children: children
          })
        });
      }

      return /*#__PURE__*/jsx(TabsContextProvider, {
        value: tabsContext,
        children: /*#__PURE__*/jsxs(Tabs$1, _objectSpread(_objectSpread({}, rest), {}, {
          className: this.getBemBlocksWith(),
          children: [/*#__PURE__*/jsxs("div", {
            className: this.getBemBlocksWith("__tab-list-wrapper"),
            children: [/*#__PURE__*/jsx(ScrollControl, {
              className: this.getBemBlocksWith("__scroll-control"),
              isEnabled: start,
              isRTL: isRTL,
              title: scrollControlStartTitle,
              type: ScrollControlTypes.start,
              onClick: this.handleScroll
            }), /*#__PURE__*/jsx(TabList, {
              "data-auto": "tab-list",
              onScroll: this.updateScrollPermissions,
              className: this.getBemBlocksWith("__tab-list"),
              children: tabs.map(this.renderTab)
            }), /*#__PURE__*/jsx(ScrollControl, {
              className: this.getBemBlocksWith("__scroll-control"),
              isEnabled: end,
              isRTL: isRTL,
              title: scrollControlEndTitle,
              type: ScrollControlTypes.end,
              onClick: this.handleScroll
            })]
          }), children]
        }))
      });
    }
  }]);

  return Tabs;
}(React.Component);

Tabs.propTypes = {
  children: _pt.node.isRequired,
  className: _pt.string,
  defaultIndex: _pt.number,
  selectedIndex: _pt.number,
  disableTabs: _pt.bool,
  isTabRequired: _pt.bool,
  i18n: _pt.shape({
    scrollControlStartTitle: _pt.string.isRequired,
    scrollControlEndTitle: _pt.string.isRequired
  }).isRequired,
  isRTL: _pt.bool,
  tabs: _pt.arrayOf(_pt.shape({
    title: _pt.string.isRequired,
    disabled: _pt.bool
  })).isRequired
};
Tabs.TabPanel = TabPanel;
Tabs.BASE_CLASSNAME = "eb-tabs";
Tabs.defaultProps = {
  defaultIndex: null,
  selectedIndex: null,
  disableTabs: false,
  isRTL: false,
  isTabRequired: false
};

export { Tabs as default };
//# sourceMappingURL=tabs-esm.js.map
